<template>
  <van-popup
    closeable
    close-icon="close"
    get-container="#app"
    :show="show"
    :style="{
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      borderRadius: '10px',
      background: 'white',
      alignItems: 'center'
    }"
  >
    <van-form
      class="form-content"
      @submit="onSubmit"
    >
      <div class="form-field">
        <!-- <div class="title">昵称<span class="star"> * </span></div>
        <van-field
          v-model="nickname"
          class="field"
          name="nickname"
          placeholder="请填写昵称"
          :rules="[{ required: true, message: '请填写昵称' }]"
        /> -->
        <div class="title">评论内容<span class="star"> * </span></div>
        <van-field
          v-model="comment"
          class="field"
          name="comment"
          required
          rows="5"
          autosize
          type="textarea"
          placeholder="请写下您的评论内容"
          show-word-limit
          :rules="[{ required: true, message: '请写下您的评论内容' }]"
        />
      </div>
      <van-button
        class="submit-btn button glass"
        type="default"
        round
        color="linear-gradient(to right, #f56c42, #feb91f)"
        native-type="submit"
        :loading="loading"
        loading-text="提交中..."
      >
        提交
      </van-button>
    </van-form>
  </van-popup>
</template>

<script>
import { Popup, Form, Button, Field, Uploader } from "vant";
import { Toast } from "@vant/compat";
import { ref, toRef } from "vue";
import Api from "../api";
import Cookies from "js-cookie";
import { useRoute } from "vue-router";
import { triggerLogin } from "@/utils/triggerLogin";

export default {
  name: "CommentForm",
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup
  },
  props: {
    selectedItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ["update:show"],
  setup(props, context) {
    console.log("props", props);
    const route = useRoute();
    const userAgentString = navigator.userAgent.toLowerCase();
    const isWechat = userAgentString.indexOf("micromessenger") >= 0;
    const isApp = userAgentString.indexOf("zsrbapp") >= 0;
    // const nickname = ref("");
    // if (localStorage.getItem("nickName"))
    //   nickname.value = localStorage.getItem("nickName");
    const comment = ref("");
    const loading = ref(false);
    const show = toRef(props, "showForm");

    const onSubmit = (values) => {
      console.log("values", values);
      if (values.comment == "") {
        Toast.fail("评论内容不得为空");
        return;
      }

      const sessionToken = sessionStorage.getItem("session_token");
      if (!sessionToken && isApp) {
        console.log("=======执行这里333333");
        triggerLogin();
        return;
      }

      //链式处理数据
      const params = {
        info_id: props.selectedItem.info_id,
        parent_id: props.selectedItem.id,
        content: values.comment
      };
      Api.postComment(params).then((res) => {
        console.log("返回", res.data);
        if (res.code == 1) {
          context.emit("update:show", false);
          comment.value = "";
          Toast.success(res.message);
          handleBuried();
        } else {
          Toast.fail(res.message);
        }
      });
    };

    //埋点
    const handleBuried = () => {
      // 南方智媒云数据上报
      window.TrackKit.zmyAdapter.commentArticle({
        article_id: route.params.id
      });
    };

    return {
      // nickname,
      comment,
      onSubmit,
      loading,
      show
    };
  }
};
</script>

<style lang="scss" scoped>
.form-content {
  width: 80%;
  margin-top: 30px;
}
.form-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
}
.form-input {
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.2);
}

.submit-btn {
  width: 50%;
  margin-top: 20px;
  margin-bottom: 10px;
}

.field {
  // border-radius: 10px;
  // --van-cell-background-color: rgb(245, 247, 250);
  // margin-bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 10px;
  background-color: rgba(255, 255, 255, 0.2);
}
.title {
  font-size: 1em;
  margin-left: 2px;
  margin-top: 10px;
  .star {
    color: red;
  }
}
</style>
